<template>
    <offer-category-mfo
        v-if="isCategoryMfoOrLoan(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-bail-loan
        v-else-if="isCategoryBailLoan(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-debit-card
        v-else-if="isCategoryDebitCard(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-credit-card
        v-else-if="isCategoryCreditCard(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-credit
        v-else-if="isCategoryCredit(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-car-credit
        v-else-if="isCategoryAutoCredit(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-hr
        v-else-if="isCategoryHR(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-mortgage
        v-else-if="isCategoryMortgage(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-betting
        v-else-if="isCategoryBetting(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-deposit
        v-else-if="isCategoryDeposit(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
    <offer-category-rko
        v-else-if="isCategoryRko(offer.offerCategories || [])"
        :offer="offer"
        :usp-placement="uspPlacement"
        :text-btn="textBtn"
        :desktop-placement="desktopPlacement"
        :mobile-placement="mobilePlacement"
    />
</template>

<script setup>
import offerCategories from '../../common/offerCategories.js';
import commonProps from '../common/сommonProps.js';
import OfferCategoryMfo from './OfferCategory/OfferCategoryMfo.vue';
import OfferCategoryBailLoan from './OfferCategory/OfferCategoryBailLoan.vue';
import OfferCategoryDebitCard from './OfferCategory/OfferCategoryDebitCard.vue';
import OfferCategoryCreditCard from './OfferCategory/OfferCategoryCreditCard.vue';
import OfferCategoryCredit from './OfferCategory/OfferCategoryCredit.vue';
import OfferCategoryCarCredit from './OfferCategory/OfferCategoryCarCredit.vue';
import OfferCategoryHr from './OfferCategory/OfferCategoryHr.vue';
import OfferCategoryMortgage from './OfferCategory/OfferCategoryMortgage.vue';
import OfferCategoryBetting from './OfferCategory/OfferCategoryBetting.vue';
import OfferCategoryDeposit from './OfferCategory/OfferCategoryDeposit.vue';
import OfferCategoryRko from './OfferCategory/OfferCategoryRko.vue';

const props = defineProps({
    offer: {
        type: Object,
        required: true,
    },
    ...commonProps(),
});

const isCategoryMfoOrLoan = arr => arr.includes(offerCategories.MFO) || arr.includes(offerCategories.LOAN) || arr.includes(offerCategories.LOAN_FREE);
// const isCategoryMFO = arr => arr.includes(offerCategories.MFO);
// const isCategoryLoan = arr => arr.includes(offerCategories.LOAN) || arr.includes(offerCategories.LOAN_FREE);
const isCategoryAutoCredit = arr => arr.includes(offerCategories.AUTO_CREDIT);
const isCategoryHR = arr => arr.includes(offerCategories.HR);
const isCategoryCreditCard = arr => arr.includes(offerCategories.CREDIT_CARD);
const isCategoryDebitCard = arr => arr.includes(offerCategories.DEBIT_CARD);
const isCategoryBailLoan = arr => arr.includes(offerCategories.BAIL_LOAN);
const isCategoryCredit = arr => arr.includes(offerCategories.CONSUMER_LOAN);
const isCategoryMortgage = arr => arr.includes(offerCategories.MORTGAGE);
const isCategoryBetting = arr => arr.includes(offerCategories.BETTING);
const isCategoryDeposit = arr => arr.includes(offerCategories.DEPOSIT);
const isCategoryRko = arr => arr.includes(offerCategories.RKO);
</script>
